"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 18.175a4.7 4.7 0 0 1 4.7-4.7h4.274a4.7 4.7 0 0 1 4.7 4.7v.35a.7.7 0 1 1-1.4 0v-.35a3.3 3.3 0 0 0-3.3-3.3H7.7a3.3 3.3 0 0 0-3.3 3.3v.35a.7.7 0 1 1-1.4 0zM9.837 6.176a2.614 2.614 0 1 1 0 5.228 2.614 2.614 0 0 1 0-5.228M13.85 8.79a4.014 4.014 0 1 0-8.028 0 4.014 4.014 0 0 0 8.028 0m6.944 1.214a.7.7 0 0 1 .002.99l-3.1 3.111a.7.7 0 0 1-.992 0l-1.9-1.907a.7.7 0 0 1 .992-.988l1.404 1.41 2.604-2.614a.7.7 0 0 1 .99-.002",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=UserWithCheckmarkIcon24.js.map